import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { isSuperAdminUser } from "../helpers/GeneralHelper";
import { getLoginActivityAccess } from "../models/UserModel";

/**
 * Resolves whether login activity UI should show (super admin, or manager with direct reports).
 */
export function useLoginActivityAccess() {
  const { state } = useAuth();
  const user = state?.user_data || {};
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const resolve = async () => {
      if (!user?.user_token) {
        setAccess({ allowed: false });
        setLoading(false);
        return;
      }

      if (isSuperAdminUser(user)) {
        setAccess({
          allowed: true,
          scope: "all",
          is_super_admin: true,
        });
        setLoading(false);
        return;
      }

      if (user.urole_type !== "manager") {
        setAccess({ allowed: false });
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const result = await getLoginActivityAccess(user.user_token);
        if (!cancelled) {
          setAccess(result || { allowed: false });
        }
      } catch {
        if (!cancelled) {
          setAccess({ allowed: false });
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    resolve();

    return () => {
      cancelled = true;
    };
  }, [user?.user_token, user?.urole_type, user?.user_role_id, user?._urole_id]);

  const canView = Boolean(
    access?.allowed && (isSuperAdminUser(user) || access?.scope === "team")
  );

  return { access, canView, loading };
}
